module.exports = __webpack_public_path__ + "assets/img/about.38a8b06c.jpg";